import { useNavigate } from 'react-router-dom';
import usePasswordResetForm from '../PasswordResetForm/usePasswordResetForm';
import { PasswordValidator } from '../../../components/ui/PasswordValidator/PasswordValidator';
import { Helpers } from '../../../utils/helpers';

interface IPasswordReset {
  token: string;
  userId: string;
  successMessage?: string;
  confirmPasswordResetEndpoint?: string;
}
export const PasswordResetForm = (params: IPasswordReset) => {
  const password = usePasswordResetForm(
    params.token,
    params.userId,
    params.confirmPasswordResetEndpoint
  );
  const navigate = useNavigate();

  return (
    <>
      {password.resetResult != null && password.resetResult && (
        <>
          <div className="alert alert-success">
            {Helpers.isNullOrWhiteSpace(params.successMessage)
              ? 'Your password has been successfully reset. An email has been sent for confirmation.'
              : params.successMessage}
          </div>
          <div>
            <button
              type="button"
              className="btn btn-primary"
              onClick={() => navigate('https://tivertongunclub.com/')}>
              Return to Website
            </button>
          </div>
        </>
      )}
      {password.validToken != null && !password.validToken && (
        <div className="alert alert-danger">
          The password reset link is either expired or invalid.
        </div>
      )}
      {password.validToken != null && password.validToken && password.resetResult === null && (
        <form onSubmit={(e) => password.handleSubmit(e)}>
          <div className="form-group">
            <PasswordValidator
              isValidCallback={password.passwordCallback}
              passwordOptions={{
                requireCurrentPassword: false,
                requireLowercase: true,
                requireUppercase: true,
                requireNumber: true,
                requireSymbol: true,
                minimumLength: 8
              }}
            />
            <div className="d-grid gap-2 mt-2">
              <button type="submit" className="btn btn-primary" disabled={!password.validPassword}>
                Change Password
              </button>
            </div>
          </div>
        </form>
      )}
    </>
  );
};
